import { SVGProps, Ref, forwardRef } from 'react';

export const BubbleRoundDoubleFilledSize24Glyph = forwardRef(
    (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
        <svg
            width={24}
            height={24}
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            ref={ref}
            {...props}
        >
            <g>
                <g>
                    <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M15 5.7c.984 0 2 .066 3 .222C17.948 1.482 13.474 0 9 0 4.5 0 0 1.5 0 6c0 2.933 1.912 4.592 4.489 5.391.548-1.881 1.83-3.253 3.45-4.152C10.001 6.093 12.598 5.7 15 5.7m-9 7.8c0 4.25 4.013 5.824 8.25 5.986V24C17.308 21.451 24 18.039 24 13.5c0-4.5-4.5-6-9-6s-9 1.5-9 6"
                        fill="currentColor"
                    />
                </g>
            </g>
        </svg>
    )
);
BubbleRoundDoubleFilledSize24Glyph.displayName = 'BubbleRoundDoubleFilledSize24Glyph';
